import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["to", "use", "exact"];
import { IconButton as FoundationsIconButton } from 'foundations-components/transitional/components/IconButton';
import AbstractRouterLink from './internal/AbstractRouterLink';
import useIsActive from './internal/useIsActive';
import { jsx as _jsx } from "react/jsx-runtime";
// Unearthing a hidden prop
const IconButton = FoundationsIconButton;

/**
 * An [`IconButton`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-iconbutton--page)
 * type component with router support.
 */
export default function UIRouterIconButton(props) {
  const {
      to,
      use,
      exact = false
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const active = useIsActive(to, exact);
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, rest, {
    use: use,
    to: to,
    active: active,
    component: IconButton
  }));
}